var React = require('react');

function TriangleDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.27574 0H0.724264C0.456993 0 0.323142 0.323142 0.512131 0.512131L4.71716 4.71716C4.87337 4.87337 5.12663 4.87337 5.28284 4.71716L9.48787 0.512131C9.67686 0.323142 9.54301 0 9.27574 0Z","fill":"currentColor"}));
}

TriangleDown.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 10 5","fill":"none"};

module.exports = TriangleDown;

TriangleDown.default = TriangleDown;
